/* @ngInject */
export default class AuthCtrl {
	constructor(
		$scope,
		$state,
		Utility,
		$window,
		$timeout,
		$rootScope,
		NavigationService,
		LocalStorageService,
		NotificationService,
		AuthenticationService
	) {
		'ngInject';
		this.$scope = $scope;
		this.$state = $state;
		this.Utility = Utility;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.NavigationService = NavigationService;
		this.LocalStorageService = LocalStorageService;
		this.NotificationService = NotificationService;
		this.AuthenticationService = AuthenticationService;

		this.init();
	}

	init() {
		this.Password = undefined;
		this.UserName = undefined;
		this.resetToken = undefined;
		this.wantToRegister = undefined;
		this.dontAskMeAgain = undefined;
		this.isRegisterFormValid = false;
		this.ConfirmPassword = undefined;

		this.Utility.loadLoader();

		this.isBusy = false;
		this.timeBetweenModals = 680;

		this._handleEvents();

		this.NavigationService.activate();
	}

	change(evt) {
		this.isRegisterFormValid =
			this.FirstName &&
			this.LastName &&
			this.Password &&
			this.ConfirmPassword &&
			this.Password === this.ConfirmPassword;
	}

	continue(evt) {
		this.closeRegisterPromptModal();

		if (this.wantToRegister) {
			const user = this.AuthenticationService.currentUser();
			this.UserName = user.UserName;
			this.$timeout(() => {
				this.showRegisterModal();
			}, timeBetweenModals);
		} else if (this.dontAskMeAgain) {
			this.AuthenticationService
				.dontShowRegisterPrompt()
				.then(
					(results) => {},
					(err) => {
						console.error('Error while opting out of the register reminder: ' + this.UserName, err);
					}
				)
				.finally(() => {
					this.init();
				});
		}
	}

	register() {
		const payLoad = {
			UserName: this.UserName,
			Password: this.Password,
			FirstName: this.FirstName,
			LastName: this.LastName
		};

		this.isBusy = true;
		this.AuthenticationService
			.registerUser(payLoad)
			.then(
				(results) => {
					if (results.WasSuccessful) {
						this.NotificationService.success('REGISTERED SUCCESSFULLY');
					} else {
						this.NotificationService.error('REGISTRATION UNSUCCESSFUL');
					}
				},
				(err) => {
					console.error('Error while registering user: ' + this.UserName, err);
					this.NotificationService.error('REGISTRATION UNSUCCESSFUL');
				}
			)
			.finally(() => {
				this.init();
				this.isBusy = true;
				this.closeRegisterModal();
			});
	}

	async login(evt, shouldRedirect) {
		this.isBusy = true;

		try {
			const results = await this.AuthenticationService.loginUser(this.UserName, this.Password);

			if (typeof results === 'object' && results.length === 2) {
				if (shouldRedirect) {
					this.$window.location = '/dashboard#!/';
				}
			} else {
				this.NotificationService.success('LOGIN UNSUCCESSFUL');
			}
		} catch (err) {
			this.NotificationService.error('LOGIN UNSUCCESSFUL');
			const payLoad = {
				isBusy: false,
				err: null
			};

			this.$rootScope.$broadcast('user-login-busy', payLoad);
			console.error(`Error while logging in user: ${this.UserName}\nError: ${err}`);
		} finally {
			this.closeLoginModal();
			this.init();
			this.isBusy = false;
		}
	}

	preShowForgotPasswordModal() {
		this.closeLoginModal();
		this.$timeout(() => {
			this.UserName = '';
			this.showForgotPasswordModal();
		}, this.timeBetweenModals - 300);
	}

	forgotPassword(userName = null) {
		this.isBusy = true;
		const promise = this.AuthenticationService.userForgotPassword(userName || this.UserName);
		promise.finally(() => {
			this.$timeout(() => {
				promise
					.then(
						(results) => {
							this.NotificationService.success('FOLLOW THE EMAIL LINK TO SET A NEW PASSWORD');
						},
						(err) => {
							console.error(`Error while resetting a password: ${err}`);

							this.NotificationService.error('PASSWORD RESET FAILED');
						}
					)
					.finally(() => {
						this.init();
						this.isBusy = false;
						this.closeForgotPasswordModal();
					});
			}, 1200);
		});
	}

	resetPassword() {
		this.isBusy = true;

		const promise = this.AuthenticationService.userResetPassword(this.Password, this.resetToken);
		promise.finally(() => {
			this.$timeout(() => {
				promise
					.then(
						(results) => {
							this.NotificationService.success('PASSWORD RESET SUCCESSFULLY');							
						},
						(err) => {
							this.NotificationService.error('FAILED. PLEASE CONTACT PRETOR GROUP.');
						}
					)
					.finally(() => {
						this.init();
						this.isBusy = false;
						this.closeRestPasswordModal();
					});
			}, 1200);
		});
	}

	closeUnsubscribe() {
		this.AuthenticationService.unsubscribeMonthlyFinancialDocs().then(
			(results) => {
				this.NotificationService.success('UNSUBSCRIBED SUCCESSFULLY');
			},
			(err) => {
				this.NotificationService.error('UNSUBSCRIBE FAILED');
				console.error(err);
			}
		);
		this.closeUnsubscribeMonthlyFinancialDocs();
	}

	_handleEvents() {

		this.$rootScope.$on('auth-modal-set-username', (event, username) => {
			this.UserName = username;
		})

		this.$scope.$on('reset-user-password', ($evt, userName) => {
			this.forgotPassword(userName);
		});

		this.$scope.$on('unsubscribe-monthly-financial-docs', ($event) => {
			this.showUnsubscribeMonthlyFinancialDocs();
		});

		this.$scope.$on('show-login-auth-modal', (event) => {
			this.showLoginModal();
		});

		this.$scope.$on('show-reset-password-auth-modal', ($event, token) => {
			this.resetToken = token;
			this.LocalStorageService.save('resetPasswordToken', token);
			this.showRestPasswordModal();
		});

		this.$scope.$on('user-logged-in', ($event, results) => {
			const profile = results && results.length > 0 ? results[1] : results;
			if (profile && profile.ProfileReminder) {
				if (profile.ProfileReminder.ShowUserAuthenticationNotSecure) {
					//this.showRegisterPromptModal();
				}
			}
		});

		this.$rootScope.$on('user-reset-password', (event, data) => {
			this.preShowForgotPasswordModal();
		});
	}
}
